export function formatDelta(ms) {
  // ms -> human readable like "1d 2h 3m 4s"
  if (!Number.isFinite(ms) || ms <= 0) return '0s';
  let s = Math.floor(ms / 1000);
  const parts = [];
  const days = Math.floor(s / 86400);
  if (days) { parts.push(`${days}d`); s -= days * 86400; }
  const hours = Math.floor(s / 3600);
  if (hours) { parts.push(`${hours}h`); s -= hours * 3600; }
  const mins = Math.floor(s / 60);
  if (mins) { parts.push(`${mins}m`); s -= mins * 60; }
  parts.push(`${s}s`);
  return parts.join(' ');
}
